import classnames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { LoginIcon, UserIcon } from '@heroicons/react/outline';
import { ChevronDownIcon } from '@heroicons/react/solid';

import { Routes } from 'constants/routes';
import styles from './UserProfileMenu.module.css';
import defaultUserAvatar from 'assets/default-user-avatar.svg';

import * as $auth from 'modules/auth';
import * as $userProfile from 'modules/userProfile';

const cls = classnames.bind(styles);

export const UserProfileMenu = ({ className }) => {
  const dispatch = useDispatch();
  const user = useSelector($auth.getCurrentUser);
  const userProfile = useSelector($userProfile.getUserProfile) ?? {};

  return (
    <Menu as="div" className={cls('relative', className)}>
      {({ open }) => (
        <>
          <Menu.Button className={cls('menu-button')}>
            <img
              src={userProfile.profilePhotoUrl ?? defaultUserAvatar}
              alt={user.name}
              className="h-8 w-8 rounded-full shadow object-cover"
            />

            <span className="ml-3 text-gray-700 text-sm font-medium">
              {userProfile.name || user.name}
            </span>

            <ChevronDownIcon
              className="block flex-shrink-0 h-5 w-5 ml-1 text-gray-400"
              aria-hidden="true"
            />
          </Menu.Button>

          <AnimatePresence>
            {open && (
              <Menu.Items
                static
                as={motion.div}
                className={cls('menu')}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{ duration: 0.2, ease: 'easeOut' }}
              >
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={Routes.Profile}
                      className={cls('menu__item', active && 'menu__item--active')}
                      style={{ color: 'inherit' }}
                    >
                      <UserIcon className="w-5 h-5 mr-2 text-gray-500" />
                      Manage profile
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={cls('menu__item', active && 'menu__item--active')}
                      onClick={() => dispatch($auth.signout())}
                    >
                      <LoginIcon className="w-5 h-5 mr-2 text-gray-500" />
                      Log out
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            )}
          </AnimatePresence>
        </>
      )}
    </Menu>
  );
};
